import React from 'react';
import Collapse from '@mui/material/Collapse';
import MuiAlert, { AlertProps as MuiAlertProps } from '@mui/material/Alert';

export interface AlertProps extends MuiAlertProps {
  show: boolean;
  message: React.ReactNode;
  mountOnEnter?: boolean;
}

const Alert = ({
  show,
  message,
  className = '',
  severity = 'error',
  mountOnEnter,
  ...rest
}: AlertProps) => (
  <Collapse in={show} mountOnEnter={mountOnEnter} className="bp-w-full">
    <MuiAlert severity={severity} className={`bp-leading-[1.43] ${className}`} {...rest}>
      {show ? message : ''}
    </MuiAlert>
  </Collapse>
);

export default Alert;
